import { isProdEnv } from 'shared/config'

export const LINK_SUPPORT = 'https://help.salesmessage.com'
export const LINK_WEBSITE = 'https://www.salesmessage.com'
export const LINK_FEEDBACK = 'https://feedback.salesmessage.com'
export const LINK_FEATURE_REQUESTS = 'https://feedback.salesmessage.com/feature-requests'
export const LINK_FAILED_MESSAGES =
  'https://help.salesmessage.com/en/articles/6458077-understanding-message-statuses?_ga=2.248595143.1147785932.1692521653-61008499.1688465089'
export const LINK_ENABLE_MICROPHONE =
  'https://help.salesmessage.com/en/articles/5463800-inbound-outbound-calling-with-salesmsg?&_ga=2.106169539.1569855396.1700134216-710223279.1678805118#h_313708a719'
export const LINK_IMPORT_YOUR_CONTACTS =
  'https://help.salesmessage.com/en/articles/3192286-import-your-contacts'
export const LINK_USE_CUSTOM_TRIGGERS =
  'https://help.salesmessage.com/en/articles/4232459-how-to-use-custom-triggers'
export const LINK_TERMS_CONDITIONS = 'https://www.salesmessage.com/terms-conditions'
export const LINK_CONVERSION_REVENUE_TRACKING =
  'https://help.salesmessage.com/en/articles/6142934-conversion-revenue-tracking'
export const LINK_DUPLE_MERGE_LEARN_MORE =
  'https://help.salesmessage.com/en/articles/6896247-contact-cleanup'
export const LINK_SMART_INBOXES = 'https://help.salesmessage.com/en/articles/6188086-smart-inboxes'
export const LINK_MAKE_INBOX_OWNER =
  'https://help.salesmessage.com/en/articles/5092893-salesmsg-inboxes'
export const LINK_MASS_MESSAGING_BEST_PRACTICES_GUIDELINES =
  'https://help.salesmessage.com/en/articles/3279821-mass-messaging-best-practices-guidelines'
export const LINK_CHATBOT_GUIDELINES =
  'https://help.salesmessage.com/en/articles/9675140-salesmsg-ai-textbot'
export const LINK_POWER_DIALER =
  'https://help.salesmessage.com/en/articles/9706177-salesmsg-power-dialer'
export const LINK_PHONE_CHECKER = 'https://help.salesmessage.com/en/articles/5803296-phonecheckr'
export const LINK_BROADCAST_AI =
  'https://help.salesmessage.com/en/articles/12311073-handle-broadcast-replies-with-salesmsg-ai'
export const LINK_APP_STORE = 'https://apps.apple.com/us/app/salesmsg-business-texting/id1450828104'
export const LINK_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.salesmessage.arcadia.app'
export const LINK_WORKFLOW_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/7851828-salesmsg-workflows'
export const LINK_KNOWLEDGE_BASE_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/10214182-salesmsg-ai-knowledge-base'
export const LINK_COMPLIANCE_LEARN_MORE_LINK =
  'https://help.salesmessage.com/en/articles/5205228-register-for-a2p-10dlc'
export const LINK_COMPLIANCE_OPT_IN_CONSENT_LEARN_MORE_LINK =
  'https://help.salesmessage.com/en/articles/8287513-sms-opt-in-guides'
export const LINK_COMPLIANCE_CALLING_LEARN_MORE_LINK =
  'https://help.salesmessage.com/en/articles/6010512-trusted-calling-stir-shaken-cnam'
export const LINK_COMPLIANCE_TOLL_FREE_LEARN_MORE_LINK =
  'https://help.salesmessage.com/en/articles/6150476-toll-free-message-verification-usa-canada'
export const LINK_COMPLIANCE_CALLING_TELEPHONY_POLICY_LINK = 'https://sti-ga.atis.org'
export const LINK_COMPLIANCE_TELECOM_TRACEBACK_GROUP = 'https://tracebacks.org'

export const LINK_KEYWORDS_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/6255763-text-to-join-keywords'
export const LINK_CAMPAIGNS_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/10907832-salesmsg-campaigns'
export const LINK_HUBSPOT_GUIDE =
  'https://help.salesmessage.com/en/articles/3188721-integrating-with-hubspot'
export const LINK_SALESFORCE_GUIDE =
  'https://help.salesmessage.com/en/articles/8261833-integrating-with-salesforce'
export const LINK_ACTIVECAMPAIGN_GUIDE =
  'https://help.salesmessage.com/en/articles/3188659-integrating-with-activecampaign'
export const LINK_INFUSIONSOFT_GUIDE =
  'https://help.salesmessage.com/en/articles/3188720-integrating-with-keap-infusionsoft'
export const LINK_PIPEDRIVE_GUIDE =
  'https://help.salesmessage.com/en/articles/3193321-integrating-with-pipedrive'
export const LINK_AIRCALL_GUIDE =
  'https://help.salesmessage.com/en/articles/10462271-integrate-your-messaging-with-aircall'
export const LINK_ZAPIER_GUIDE =
  'https://help.salesmessage.com/en/articles/3354852-integrating-with-zapier'
export const LINK_MAKE_GUIDE = 'https://help.salesmessage.com/en/articles/8140892-make-integration'
export const LINK_SLACK_GUIDE =
  'https://help.salesmessage.com/en/articles/6600379-integration-for-slack'
export const LINK_INTERCOM_GUIDE =
  'https://help.salesmessage.com/en/articles/7436196-new-salesmsg-for-intercom'
export const LINK_GOOGLE_GUIDE =
  'https://help.salesmessage.com/en/articles/5565198-transferring-a-google-voice-number-to-salesmsg'
export const LINK_WEBHOOK_GUIDE =
  'https://help.salesmessage.com/en/articles/6884649-salesmsg-webhooks'
export const LINK_CARRIER_AND_CTIA_GUIDELINES =
  'https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms'
export const LINK_CTIA_SHORT_CODE_HANDBOOK =
  'https://api.ctia.org/wp-content/uploads/2024/01/CTIA-Short-Code-Monitoring-Handbook-v1.9-FINAL.pdf'
export const LINK_QUICK_LINKS_GUIDE =
  'https://help.salesmessage.com/en/articles/10531943-contact-quick-links'
export const LINK_THROUGHPUT_MESSAGE_GUIDE =
  'https://help.salesmessage.com/en/articles/6209896-message-throughput-mps-and-trust-scores-for-a2p-10dlc'
export const LINK_CALENDLY_GUIDE =
  'https://help.salesmessage.com/en/articles/10834828-integrating-with-calendly'
export const LINK_ZOHO_GUIDE =
  'https://help.salesmessage.com/en/articles/11783205-integrating-with-zoho'
export const LINK_SALESMSG_MCP_GUIDE =
  'https://help.salesmessage.com/en/articles/15352376-use-salesmsg-via-mcp'
export const LINK_AUTO_REMINDERS_LEARN_MORE =
  'https://help.salesmessage.com/en/articles/9675140-salesmsg-ai-agents#h_ceec38215c'
export const LINK_AI_CHECKR_LEARN_MORE =
  'https://help.salesmessage.com/en/articles/11391519-ai-compliance-checkr#h_3b54e479a5'
export const LINK_BOOKING_AI_AGENT =
  'https://help.salesmessage.com/en/articles/11487601-booking-ai-agent'
export const LINK_EXISTING_MOBILE_NUMBER_WITH_SALESMSG =
  'https://help.salesmessage.com/en/articles/3193427-can-i-use-my-existing-mobile-number-with-salesmsg'
export const LINK_TWILIO_GUIDE =
  'https://help.salesmessage.com/en/articles/8594583-integrating-with-twilio#h_90aabd58d8'
export const LINK_TRIGGERS_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/10159926-triggers-2-0'
export const LINK_BROADCAST_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/3280149-broadcasts-2-0'
export const LINK_RINGLESS_VOICEMAIL_BEST_PRACTICES =
  'https://help.salesmessage.com/en/articles/8533572-ringless-voicemail-best-practices-guideline'
export const LINK_WHICH_NUMBER_IS_RIGHT_FOR_MY_NEEDS =
  'https://help.salesmessage.com/en/articles/6210336-which-number-is-right-for-my-needs'
export const LINK_INTERNATIONAL_COMPLIANCE_GUIDE =
  'https://help.salesmessage.com/en/articles/11402037-international-compliance'
export const LINK_REFERRALS_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/4501629-affiliate-program-overview'
export const LINK_REFERRALS_PARTNERSTACK = 'https://market.partnerstack.com/sales/salesmsg'
export const LINK_REFERRALS_PARTNERS = 'https://www.salesmessage.com/partners'
export const LINK_DOUBLE_OPT_IN_GUIDE =
  'https://help.salesmessage.com/en/articles/3291913-double-opt-in'
export const LINK_CAN_I_USE_INTERNATIONALLY_GUIDE =
  'https://help.salesmessage.com/en/articles/3276821-can-i-use-salesmsg-internationally'
export const LINK_EMAIL_TO_SMS =
  'https://help.salesmessage.com/en/articles/4770218-email-notifications-and-email-to-sms'
export const LINK_AIRCALL_INTEGRATION = 'https://dashboard.aircall.io/integrations/hub/salesmsg'
export const LINK_AIRCALL_WORKSPACE =
  'https://app.aircall.io/workspace/inbox/conversations?category=open'
export const LINK_AIRCALL_NOT_READY_TO_BE_ASSIGNED =
  'https://help.salesmessage.com/en/articles/4808864-aircall-numbers-not-ready-to-be-assigned'
export const LINK_INTEGRATELY =
  'https://help.salesmessage.com/en/articles/11983873-integrately-integration'
export const LINK_KERAGON_GUIDE =
  'https://help.salesmessage.com/en/articles/12066459-keragon-integration'
export const LINK_N8N_GUIDE = 'https://help.salesmessage.com/en/articles/12066462-n8n-integration'
export const LINK_AIRCALL_INTEGRATING_GUIDE =
  'https://help.salesmessage.com/en/articles/10462271-integrating-with-aircall'
export const LINK_RCS_GUIDE =
  'https://help.salesmessage.com/en/articles/12232116-rcs-messaging-in-salesmsg'
export const LINK_RCS_COMPLIANCE_GUIDE =
  'https://help.salesmessage.com/en/articles/15433331-rcs-compliance'
export const LINK_TAGS_GUIDE =
  'https://help.salesmessage.com/en/articles/4199152-adding-tags-to-contacts'
export const LINK_SAVED_REPLIES_GUIDE =
  'https://help.salesmessage.com/en/articles/3342047-saved-replies'
export const LINK_CUSTOM_FIELDS_GUIDE =
  'https://help.salesmessage.com/en/articles/5146553-custom-fields'
export const LINK_AMPERSAND_INTEGRATION_GUIDE =
  'https://help.salesmessage.com/en/articles/12427209-new-integrations-for-smarter-workflows'
export const LINK_INSIGHTLY_INTEGRATION_GUIDE =
  'https://help.salesmessage.com/en/articles/14060920-integrating-with-insightly'
export const LINK_SALESMSG_STATUS_PAGE = isProdEnv
  ? 'https://status.salesmessage.com'
  : 'https://status.salesmsgdev.com'
export const LINK_SALESMSG_PERFORMANCE_DASHBOARD =
  'https://dashboards.salesmessage.com/public-dashboards/cc21cb2fa5734b92889b915b586dcf3c'
export const LINK_CLOSE_INTEGRATION_GUIDE =
  'https://help.salesmessage.com/en/articles/14060892-integrating-with-close'
export const LINK_AGENTFORCE_INTEGRATION_GUIDE =
  'https://help.salesmessage.com/en/articles/14019378-agentforce-ai-agent'
export const LINK_AGENTFORCE_INSTALL_PACKAGE =
  'https://login.salesforce.com/packaging/installPackage.apexp?p0=04tWU000000S3PZYA0'
export const LINK_ATIO_INTEGRATION_GUIDE =
  'https://help.salesmessage.com/en/articles/14060882-integrating-with-attio'
export const LINK_FRONT_INTEGRATION_GUIDE =
  'https://help.salesmessage.com/en/articles/14060908-integrating-with-front'
export const LINK_OUTREACH_INTEGRATION_GUIDE =
  'https://help.salesmessage.com/en/articles/14060864-integrating-with-outreach'
export const LINK_GOOGLE_SHEETS_GUIDE =
  'https://help.salesmessage.com/en/articles/14664894-integrating-with-google-sheets-and-google-doc'
export const LINK_GOOGLE_DOCS_GUIDE =
  'https://help.salesmessage.com/en/articles/14664894-integrating-with-google-sheets-and-google-doc'
export const LINK_CREDIT_USAGE_LEARN_MORE =
  'https://help.salesmessage.com/en/articles/4697613-how-long-can-a-text-message-be'
export const LINK_HOW_DO_MESSAGE_CREDITS_WORK =
  'https://help.salesmessage.com/en/articles/3327206-how-do-message-credits-work'
export const LINK_CLICK_TO_TEXT_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/12840775-capture-contacts-with-click-to-text-or-qr-code'
export const LINK_HIPAA_COMPLIANCE =
  'https://help.salesmessage.com/en/articles/12889944-hipaa-compliance'
export const LINK_HIPAA_SUPPORT_EMAIL = 'mailto:hipaa-support@salesmessage.com'
export const LINK_CALL_FORWARDING_GUIDE =
  'https://help.salesmessage.com/en/articles/3172628-set-up-call-forwarding'
export const LINK_ROLES_PERMISSIONS_GUIDE =
  'https://help.salesmessage.com/en/articles/5773786-roles-permissions'
export const LINK_MEETINGS_HUBSPOT_1 =
  'https://meetings.hubspot.com/tristan-corrinmeet/plan-upgrade-sales'
export const LINK_MEETINGS_HUBSPOT_2 =
  'https://meetings.hubspot.com/thiago-nascimento1/upgrade-request'
export const LINK_AUTH_APP =
  'https://help.salesmessage.com/en/articles/6797119-two-factor-authentication'

export const LINK_MESSAGING_SERVICE_AGREEMENT =
  'https://www.salesmessage.com/messaging-service-agreement-05-2024'
export const LINK_TERMS_OF_USE = 'https://www.salesmessage.com/terms-of-use'
export const LINK_PRIVACY_POLICY = 'https://www.salesmessage.com/privacy-policy'
export const LINK_BILLING_POLICY = 'https://www.salesmessage.com/billing-policy'
export const LINK_ACCEPTABLE_USE_POLICY = 'https://www.salesmessage.com/acceptable-use-policy'
export const LINK_SECURITY_INFORMATION = 'https://www.salesmessage.com/security-information'
export const LINK_HELP_QUIET_HOURS =
  'https://help.salesmessage.com/en/articles/13342176-quiet-hours'
export const LINK_HELP_SMART_CALL_FLOW =
  'https://help.salesmessage.com/en/articles/13543645-salesmsg-smart-call-flow'

export const LINK_DEVELOPER_HELP_GUIDE =
  'https://help.salesmessage.com/en/articles/4855418-the-salesmsg-api'
export const REFRESH_TOKEN_DOCS_URL = `${window.location.origin}/api/docs#/Authorization/Refresh%20personal%20access%20token`
export const LINK_DEVELOPER_API_DOCS_V2 = `${window.location.origin}/api/docs`

export const LINK_HUBSPOT_CHANNEL_INFO =
  'https://help.salesmessage.com/en/articles/10265193-new-text-from-hubspot-inbox-help-desk-with-custom-channels'
export const LINK_INTEGRATION_PREMIUM_DOWNLOAD =
  'https://appexchange.salesforce.com/appxListingDetail?listingId=ff12551a-f9ad-44bb-a11f-cad4ac0af4d0'
export const LINK_SALESFORCE_PREMIUM_DOC =
  'https://help.salesmessage.com/en/articles/8261833-integrating-with-salesforce'
export const LINK_TEAMS_GUIDE = 'https://help.salesmessage.com/en/articles/9398320-salesmsg-teams'
export const LINK_HELP_GET_A_BUSINESS_TAX_ID =
  'https://help.salesmessage.com/en/articles/13715008-get-your-business-id-for-free'
export const LINK_COMPLIANCE_WHERE_CAN_I_FIND_BUSINESS_INFO =
  'https://help.salesmessage.com/en/articles/14840688-10dlc-where-can-i-find-my-business-info'
export const LINK_VOICEMAIL_DROP =
  'https://help.salesmessage.com/en/articles/9549330-voicemail-drop'
export const LINK_SMART_VIEWS_FILTERS =
  'https://feedback.salesmessage.com/feature-requests/p/smart-views-filters'
export const LINK_SEARCH_SMART_VIEWS =
  'https://help.salesmessage.com/en/articles/13713949-salesmsg-search-smart-views'
export const LINK_CUSTOM_SHORT_URL =
  'https://help.salesmessage.com/en/articles/8851275-custom-short-url'
export const LINK_URL_SHORTENER_GUIDE =
  'https://help.salesmessage.com/en/articles/5413527-url-shortener'
export const LINK_CALL_WHISPER =
  'https://help.salesmessage.com/en/articles/5463800-inbound-outbound-calling-with-salesmsg-what-you-can-do-how-it-works#h_80ecf4770e'
export const LINK_AI_AGENT = 'https://help.salesmessage.com/en/articles/9675140-salesmsg-ai-agent'
export const LINK_PROHIBITED_SMS_USE_CASES =
  'https://help.salesmessage.com/en/articles/6811688-prohibited-sms-use-cases'
export const LINK_SURVEYS_GUIDE = 'https://help.salesmessage.com/en/articles/14736499-surveys'
export const LINK_SURVEYS_FOLLOW_UP_LEARN_MORE =
  'https://help.salesmessage.com/en/articles/14736499-salesmsg-surveys#h_a7f0followup'
export const LINK_REVIEWS_GUIDE = 'https://help.salesmessage.com/en/articles/14736759-reviews'
export const LINK_HELP_UK_COMPLIANCE =
  'https://help.salesmessage.com/en/articles/11402037-international-compliance-united-kingdom'
export const LINK_HELP_TRIAL_COMPLIANCE =
  'https://help.salesmessage.com/en/articles/8594576-free-trial-in-salesmsg'
export const LINK_10DLC_LIMITS_EXCEEDED =
  'https://help.salesmessage.com/en/articles/8986790-10dlc-limits-exceeded-how-to-upgrade'

export const getSalesmsgTypeFormLink = ({
  email,
  user_id,
  org_id,
}: {
  email: string
  user_id: number
  org_id: number
}) => {
  return `https://form.typeform.com/to/bap50Qpr#email=${encodeURIComponent(
    email
  )}&user_id=${encodeURIComponent(user_id.toString())}&org_id=${encodeURIComponent(
    org_id.toString()
  )}`
}
